import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { liveUrl } from "../../utils/Constant";

const Login = () => {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMsg("");

        try {
            const res = await axios.post(`${liveUrl}/auth/login`, {
                email,
                password,
            });

            // console.log(res)

            if (res.data.data && res.data.data.token) {
                localStorage.setItem("token", res.data.data.token);
                toast.success("Login Successful!");

                setTimeout(() => {
                    window.location.href = "/dashboard";
                }, 800);
            }
        } catch (err) {
            console.log(err);
            if (err.response) {
                setErrorMsg(err.response.data.message || "Login failed");
            } else {
                setErrorMsg("Network error, try again");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <form className="login-form" onSubmit={handleLogin}>
                <h2>Login to Account</h2>
                <p>Please enter your email and password to continue</p>

                {errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}

                <label>Email address:</label>
                <input
                    type="email"
                    placeholder="Enter Your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />

                <label>Password:</label>
                <input
                    type="password"
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />

                <button type="submit" disabled={loading}>
                    {loading ? "Signing in..." : "Sign In"}
                </button>
            </form>
        </div>
    );
};

export default Login;
